import React, { useState } from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Clock, AlertTriangle, Info, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface TeamAlertsProps {
  isAdmin: boolean;
  canEditNominations: boolean;
  canEditPlayers: boolean;
  hasCorrectNominations: boolean;
  nominatedCount: number;
}

const TeamAlerts: React.FC<TeamAlertsProps> = ({
  isAdmin,
  canEditNominations,
  canEditPlayers,
  hasCorrectNominations,
  nominatedCount
}) => {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div className="relative mb-4">
      {canEditPlayers && canEditNominations && !hasCorrectNominations && (
        <Alert variant="destructive" className="mb-4">
          <AlertTriangle className="h-4 w-4" />
          <AlertTitle>Nomination requirement</AlertTitle>
          <AlertDescription>
            You must nominate 5 players before your first game. Currently you have nominated {nominatedCount} players.
            <br />
            Please refer to the rules in the navbar dropdown to understand more about nominations.

          </AlertDescription>
        </Alert>
      )}

      {canEditPlayers && canEditNominations && (
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            className="flex items-center space-x-2 text-sm text-muted-foreground hover:text-foreground"
            onClick={() => setShowInfo(!showInfo)}
          >
            {showInfo ? (
              <>
                <X className="h-4 w-4" />
                <span>Hide Info</span>
              </>
            ) : (
              <>
                <Info className="h-4 w-4" />
                <span>Show Info</span>
              </>
            )}
          </Button>
        </div>
      )}

      {showInfo && canEditPlayers && canEditNominations && hasCorrectNominations && (
        <Alert className="mt-2">
          <Info className="h-4 w-4" />
          <AlertTitle>Important information</AlertTitle>
          <AlertDescription>
            Results cannot be entered if nominated players have not been locked in. Once locked in, only GGU can edit any mistakes. Please refer to the rules in the navbar dropdown to understand more about nominated players.
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
};

export default TeamAlerts;